import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { textFieldDefaults } from "../formControlDefaults.js";

Password.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoComplete: PropTypes.string,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function Password(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    autoComplete = null,
    showErrorText = false,
    disabled = false,
  } = props;

  let inputValue = value;

  if (!value) inputValue = "";
  let helperText = "";
  if (showErrorText) helperText = error;

  return (
    <TextField
      {...textFieldDefaults}
      type="password"
      variant="outlined"
      label={item.label}
      name={item.name}
      value={inputValue}
      onChange={onChange}
      disabled={disabled}
      {...(autoComplete && { autoComplete })}
      {...(error && { error: true, helperText: helperText })}
    />
  );
}
